import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mother-tongue-education',
  templateUrl: './mother-tongue-education.component.html',
  styleUrls: ['./mother-tongue-education.component.css']
})
export class MotherTongueEducationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
